import { render } from "./MyTopBarButtonSignIn.vue?vue&type=template&id=53c06108"
import script from "./MyTopBarButtonSignIn.vue?vue&type=script&lang=js"
export * from "./MyTopBarButtonSignIn.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__